import { IsInt, IsString } from 'class-validator';
import { Type } from 'class-transformer';
import { ThirdPartyIntegrationTypes } from '../../enum/third-party-integration-types.enum';

export class ThirdPartyIntegrationQueryStatusDTO {
  @IsString()
  integration: ThirdPartyIntegrationTypes;

  @IsInt()
  @Type(() => Number)
  merchantId: number;
}
